import './About.scss'
import Navigation from '../components/Navigation'

const About = () => {
  return (
    <div className="about-page">
      <Navigation />
      <div className="about-container">
        <h1 className="about-title">About the Ford Reliability Air Tour</h1>
        
        <div className="about-content">
          <section className="about-section">
            <h2>A Vision Takes Flight</h2>
            <p>
              In 1925, Henry Ford embarked on an ambitious mission to transform public perception of aviation. 
              The Ford Reliability Air Tour was more than just a series of flights—it was a bold statement 
              that airplanes could be reliable, practical machines for everyday transportation and commerce.
            </p>
          </section>

          <section className="about-section">
            <h2>The Challenge</h2>
            <p>
              At a time when aviation was still considered dangerous and unreliable, Ford sought to demonstrate 
              that properly designed and manufactured aircraft could operate with the same dependability as 
              automobiles. The tour covered thousands of miles across the United States, with strict 
              schedules and demanding conditions.
            </p>
          </section>

          <section className="about-section">
            <h2>Innovation and Legacy</h2>
            <p>
              The Ford Trimotor, affectionately known as the "Tin Goose," became the star of these tours. 
              With its all-metal construction and three reliable engines, it represented the cutting edge 
              of aviation technology. These tours helped establish regular air mail routes and passenger 
              services that would eventually evolve into modern commercial aviation.
            </p>
          </section>

          <section className="about-section">
            <h2>A Hundred Years Later</h2>
            <p>
              Today, we commemorate this pioneering spirit that dared to imagine a world connected by air. 
              The Ford Reliability Air Tour planted the seeds for an industry that would shrink the globe, 
              making distant places accessible and transforming how we think about travel, commerce, and 
              human connection.
            </p>
          </section>
        </div>
      </div>
    </div>
  )
}

export default About